/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-05-15 14:37:23
 * @LastEditors: changfeng
 * @LastEditTime: 2024-09-09 18:12:02
 */
import { reactivate } from "@/api/modules/plan";

export default {
	"billing.blank.text": "立即开始7天免费试用并充分利用您的广告预算！",
	"billing.blank.button.cancel try": "取消试用",
	"billing.blank.button.now renew": "立即续费",
	"billing.blank.button.Pay Now": "立即付款",
	"billing.blank.button.Purchase Subscription": "购买套餐",
	"billing.blank.button.Confirm Cancellation": "确认取消试用？",
	"billing.blank.button.Confirm Cancellation button": "确认取消",
	"billing.blank.button.Cancellation.try.title": "取消试用后，已使用的代金券将不予返还。是否仍要取消试用？",
	"billing.blank.button.upgrade": "升级套餐",

	"billing.blank.button": "订阅套餐",
	"billing.free.user.button": "自动续费",

	"billing.title": "{{name}}的账单",
	"billing.trialText": "试用到期日期：{{count}}",
	"billing.notExpireText": "订阅到期日期：{{count}}",
	"billing.expiredText": "您的套餐已到期",

	"billing.plan.name.standard": "标准版",
	"billing.plan.name.professional": "专业版",
	"billing.plan.title": "您当前订阅的是",
	"billing.plan.item.unlimitedProfiles": "无限量授权广告账户",
	"billing.plan.item.accounts": "连接的广告账户数量上限{{limit}}个",
	"billing.plan.item.rule": "创建规则数量上限{{ruleLimit}}条，规则生效的广告账户数量上限{{activeLimit}}个",
	"billing.plan.item.ads": "一键创建和管理广告",
	"billing.plan.item.team": "团队成员人数上限{{limit}}个",
	"billing.plan.item.dashboard": "清晰直观的仪表盘数据",
	"billing.plan.item.rulesFrequency": "规则每{{frequency}}分钟运行一次",
	"billing.plan.item.standard.support": "工作日通过邮件提供技术支持",
	"billing.plan.item.professional.support": "工作日通过微信提供技术支持",
	"billing.plan.item.support": "工作日通过邮件提供技术支持",

	"billing.plan.unsubscribe.button": "取消订阅",
	"billing.plan.unsubscribe.modal.title": "确认取消订阅？",
	"billing.plan.unsubscribe.modal.text":
		"您的套餐于<important>{{date}}</important>到期，取消订阅后，已使用的代金券将不予返还。是否仍要取消订阅？",
	"billing.plan.unsubscribe.modal.text.trial": "您的订阅将立即结束。",
	"billing.plan.unsubscribe.modal.text.notTrial": "您的订阅将在订阅周期结束时取消。",
	"billing.plan.unsubscribe.modal.ok": "确认",
	"billing.plan.unsubscribe.modal.cancel": "取消",
	"billing.plan.unsubscribe.message.success": "您的订阅已成功取消",
	"billing.plan.reactivate.message.success": "您的订阅套餐已重新激活",
	"billing.plan.upgrade.button": "升级套餐",
	"billing.payment.cancel.countdown": "剩余支付时间",
	"billing.payment.cancel.countdown.last": "，否则订单将自动失效",
	"billing.payment.cancel.countdown.minute": "分",
	"billing.payment.cancel.countdown.seconds": "秒",

	"billing.payment.cancel.button": "取消支付",
	"billing.payment.cancel.modal.title": "取消支付",
	"billing.payment.cancel.modal.text": "是否确定要取消支付？",
	"billing.payment.cancel.modal.ok": "取消支付",
	"billing.payment.payNow.button": "立即支付",

	"billing.pending.title": "待支付订单",
	"billing.history.title": "支付历史",

	"billing.table.column.invoiceId": "账单ID",
	"billing.table.column.plan": "订阅套餐",
	"billing.table.column.plan.standard": "标准版",
	"billing.table.column.plan.professional": "专业版",
	"billing.table.column.amount": "价格",
	"billing.table.column.paymentType": "支付类型",
	"billing.table.column.paymentType.monthly": "按月付款",
	"billing.table.column.paymentType.upgrade": "升级费用",
	"billing.table.column.paymentType.refund": "退款",
	"billing.table.column.paymentType.once": "一次性付款",
	"billing.table.column.paymentDate": "支付日期",
	"billing.table.column.status": "支付状态",
	"billing.table.column.status.pending": "待支付",
	"billing.table.column.status.success": "支付成功",
	"billing.table.column.status.failed": "支付失败",
	"billing.table.column.status.canceled": "支付被取消",

	"billing.renew": "代金券续订",
	"billing.coupon.total": "代金券总额:  <important>{{ amount }}</important>  USD",
	"billing.coupon.useCoupon": "使用代金券",
	"billing.coupon.useCoupon.mesasge": "实际支付金额不得小于{{dollar}}",
	"billing.coupon.useCoupon.description": "本次支付的是下一个订阅周期的续订费用",

	"billing.coupon.plan": "套餐",
	"billing.coupon.plan.price": "价格",

	"billing.coupon.useCoupon.payment.total": "合计",

	"billing.plan.Expires": "订阅到期日期: {{time}}",

	"billing.plan.Expires.Within seven days.tips":
		"您的专业版套餐将在7天后到期。为避免服务中断，请尽早续订标准版或专业版套餐。如需升级至企业版套餐，请联系客服人员。",

	"billing.reactivate.confirm": "重新激活订阅",

	"billing.degradation.confirm": "降级套餐",
	"billing.degradation.confirm.tips":
		"您当前订阅的是<important>{{Plan}}</important>套餐，若更改为标准版套餐，请先将您的权益作如下调整：",
	"billing.degradation.confirm.tips.list1": "连接的广告账户数量控制在 <important>{{count}}</important> 个以内 ",
	"billing.degradation.confirm.tips.list2": "规则生效的广告账户数量控制在<important>{{count}}</important>个以内",
	"billing.degradation.confirm.tips.list3": "规则创建数量控制在<important>{{count}}</important>条以内",
	"billing.degradation.confirm.tips.list4": "规则生效频率调整为每 <important>{{count}}</important>分钟一次",
	"billing.degradation.confirm.tips.list5": "团队成员数量控制在<important>{{count}}</important>个以内",
	"billing.degradation.modal.failed.tip": "温馨提示",
	"billing.degradation.modal.failed.content.before": "请将",
	"billing.degradation.modal.failed.content.after": "才可降级套餐"
};
